export default function debounce(cb, timeout) {
    let timer = null;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
            cb(...arguments);
        }, timeout);
    };
}